//import styled from "styled-components";
import {MainBodyContentContainer} from "@sc/custom.styled";

export const ReadingChallengeContainer=MainBodyContentContainer.extend`
 position:relative;
 padding:0px 14px;
 min-height: calc(100vh - 110px);
 border-radius:10px;
`;
